import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import ServiceForm, {
  ServiceFormFields,
} from '../../components/Service/ServiceForm';
import { useAuth } from '../../contexts/auth';
import api from '../../services/api';

export default function ServicesEdit() {
  const {
    user: { organization },
  } = useAuth();
  const { id } = useParams();
  const navigate = useNavigate();

  const [isLoading, setIsLoading] = useState(true);
  const [formFields, setFormFields] = useState<ServiceFormFields>(
    null as unknown as ServiceFormFields
  );
  const [formErrors, setFormErrors] = useState({});

  async function getService() {
    if (organization && id) {
      const response = await api.get(
        `organizations/${organization.id}/services/${id}`
      );

      setFormFields({
        name: response.data.name,
        price: response.data.price,
      });
      setIsLoading(false);
    }
  }

  const onSubmit = async (data: ServiceFormFields) => {
    try {
      await api.put(`organizations/${organization.id}/services/${id}`, data);

      navigate('/services');
    } catch (e: any) {
      if (e.response.data.errors) {
        setFormErrors(e.response.data.errors);
      }
    }
  };

  useEffect(() => {
    getService();
  }, [organization, id]);

  return (
    <ServiceForm
      isLoading={isLoading}
      title={`Editar Serviço ${id}`}
      formFields={formFields}
      formErrors={formErrors}
      onSubmit={onSubmit}
    />
  );
}
